/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { conversationDestroy } from '../../axios/conversationDestroy'
import type {
	ConversationDestroyError,
	ConversationDestroyPathParams,
	ConversationDestroyResponse,
} from '../../types/ConversationDestroy'

export const conversationDestroyMutationKey = () => [{ url: '/ai/conversations/:conversationId' }] as const

export type ConversationDestroyMutationKey = ReturnType<typeof conversationDestroyMutationKey>

export type ConversationDestroyVariables = {
	conversationId: ConversationDestroyPathParams['conversationId']
}

/** @see backend/nexus/modules/AIAssistant/Http/Controllers/ConversationController.php ConversationController::destroy */
export function useConversationDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		ConversationDestroyResponse,
		AxiosError<ConversationDestroyError>,
		ConversationDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: conversationDestroyMutationKey(),
		mutationFn: ({ conversationId }: ConversationDestroyVariables) =>
			conversationDestroy(conversationId, config).then(res => res.data),
		...options,
	})
}
